module.exports = __webpack_public_path__ + "img/0x0957c57c9eb7744850dcc95db5a06ed4a246236e.316551a1.png";